<template>
  <Container class="my-8 my-md-14 px-4">
    <v-row no-gutters justify="space-between">
      <v-col cols="12" sm="6" class="d-flex flex-column" data-cy="footerTextWithLogo">
        <Logo
          :link="logoLink"
          :external="headerSettings.isLogoExternal"
          :external-logo-target="headerSettings.externalLogoTarget"
        />
        <div class="my-6">
          <div
            v-if="$route.path.includes('/rs-asistent')"
            v-html="$t('footer.perex.rsAssistant')"
          ></div>
          <div
            v-else-if="$route.path.includes('/astmaHelp')"
            v-html="$t('footer.perex.astmaHelp')"
          ></div>
          <div
            v-else-if="$route.path.includes('/cekarna')"
            v-html="$t('footer.perex.virtualWaitingRoom')"
          ></div>
          <div
            v-else-if="$route.name && $route.name.startsWith('thematicCounselling') && isPutinSucks"
            v-html="$t('putinSucks.footer.perex')"
          ></div>
          <div v-else v-html="addNbsp($t('footer.perex.default'))"></div>
        </div>

        <AppButtons
          link-app-store="https://apps.apple.com/cz/app/ul%C3%A9ka%C5%99e-cz/id1488852248"
          link-google-play="https://play.google.com/store/apps/details?id=cz.ulekare.app&hl=cs&gl=US"
          google-first
          class="mb-4"
        />

        <div v-if="header === 'thematicCounselling' && !isPutinSucks">
          <v-row no-gutters align="center" justify="start">
            <v-col class="mr-4 grey-darken-1--text" cols="auto">Ve spolupráci s:</v-col>
            <v-col><img src="@/assets/img/partner-novartis-header.png" alt="Novartis" /></v-col>
          </v-row>
          <p class="mt-6 text-body-small grey-darken-1--text" v-html="$t('migraine.footer')"></p>
        </div>
        <v-spacer />
        <FooterBottomDisclaimer
          :terms-and-conditions-link="termsAndConditionsLink"
          class="d-none d-md-block mt-12"
          data-cy="footerInfoUlekare"
        />
      </v-col>
      <v-col cols="12" sm="4" md="3" data-cy="footerCompanyList">
        <h6 class="mb-4">{{ $t('footer.companyTitle') }}</h6>
        <LinkList :items="companyList" data-cy="footerCompanyListItems" />
      </v-col>
    </v-row>

    <FooterBottomDisclaimer
      :terms-and-conditions-link="termsAndConditionsLink"
      class="d-md-none mt-8"
    />
  </Container>
</template>

<script>
import { mapGetters } from 'vuex';
import lodash from 'lodash';
import Container from '@/components/Atoms/Container';
import Logo from '@/components/Atoms/Logo';
import AppButtons from '@/components/Atoms/AppButtons';
import FooterBottomDisclaimer from '@/components/Atoms/FooterBottomDisclaimer';
import LinkList from '@/components/Molecules/LinkList';

export default {
  name: 'FooterGeneral',
  components: { LinkList, FooterBottomDisclaimer, AppButtons, Logo, Container },
  computed: {
    ...mapGetters({
      partnerData: 'hrbPartner/partnerData',
      header: 'general/header',
      headerSettings: 'general/headerSettings'
    }),
    companyList() {
      let links = this.$t('footer.companyList', { returnObjects: true });
      if (this.isPutinSucks) {
        return links.filter(
          link => link.linkType !== 'external' && link.partnerLink !== 'forCompanies'
        );
      }
      return links;
    },
    logoLink() {
      return this.headerSettings.logoLink || 'index';
    },
    termsAndConditionsLink() {
      if (
        this.$route.name &&
        this.$route.name.startsWith('hrb') &&
        !lodash.isEmpty(this.partnerData)
      ) {
        return 'hrbTermsAndConditions';
      }
      if (this.header === 'thematicCounselling') {
        return this.isPutinSucks
          ? 'thematicCounsellingTermsAndConditionsUA'
          : 'thematicCounsellingTermsAndConditions';
      }
      return 'termsAndConditions';
    }
  }
};
</script>
